import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { Onboarding } from './Onboarding';
import { isOnboardingDone, markOnboardingDone } from '../lib/onboarding';

export function MainLayout() {
  const navigate = useNavigate();
  // Вычисляем один раз на маунте: показывать ли вводные экраны новому пользователю.
  const [showOnboarding, setShowOnboarding] = useState(() => !isOnboardingDone());

  if (showOnboarding) {
    return (
      <Onboarding
        onSkip={() => {
          markOnboardingDone();
          setShowOnboarding(false);
        }}
        onFinish={() => {
          markOnboardingDone();
          setShowOnboarding(false);
          navigate('/pantry');
        }}
      />
    );
  }

  // Контейнер прозрачный — сквозь него виден тёплый фон-градиент body.
  // pb: высота нижней навигации + «домашний индикатор» (safe-area) iPhone.
  return (
    <div className="mx-auto min-h-screen max-w-md pb-[calc(5.5rem+env(safe-area-inset-bottom))]">
      <Outlet />
      <BottomNav />
    </div>
  );
}
